import { render, staticRenderFns } from "./Video-upload.vue?vue&type=template&id=1139c402&scoped=true"
import script from "./Video-upload.vue?vue&type=script&lang=js"
export * from "./Video-upload.vue?vue&type=script&lang=js"
import style0 from "./Video-upload.vue?vue&type=style&index=0&id=1139c402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1139c402",
  null
  
)

export default component.exports